import { useState } from "react";
import { CellProps } from "react-table";
import Input from "src/components/inputs/Input";
import ImageTextCell from "src/components/tables/cells/ImageTextCell";
import TextCell from "src/components/tables/cells/TextCell";
import { ProductType } from "./product-types";

const useProductsTableColumns = ({
  handleInputQuantityChange,
}: {
  handleInputQuantityChange: (quantity: string, index: number) => void;
}) => {
  return [
    {
      Header: "Product Name",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: ({ value, row: { original } }: CellProps<ProductType>) => (
        <ImageTextCell
          value={value}
          imageSrc={original.image}
          className="items-center justify-start"
        />
      ),
    },
    {
      Header: "Price",
      accessor: "price",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Stock Quantity",
      accessor: "stock",
      className: "min-w-[150px]",
      Cell: ({ row: { original } }: CellProps<ProductType>) => (
        <TextCell value={original?.stock} />
      ),
    },
    {
      Header: "Category",
      accessor: "category",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Input Quantity",
      accessor: "inputQuantity",
      className: "min-w-[150px]",
      Cell: ({ row }: CellProps<ProductType>) => {
        const [value, setValue] = useState(row.original.inputQuantity ?? "");
        return (
          <Input
            onChange={({ target: { value } }) => setValue(value)}
            onBlur={({ target }: any) => {
              handleInputQuantityChange(target.value, row.index);
            }}
            name="inputQuantity"
            label=""
            value={value}
            error={
              Number(row.original.inputQuantity) > row.original.stock
                ? "Exceed"
                : ""
            }
          />
        );
      },
    },
  ];
};

export default useProductsTableColumns;
